/**
 * AIF-01 — small active/inactive status dot for the AI-Models tables
 * (filled accent when active, hollow muted when not).
 */
import { Box, Tooltip } from "@mui/material";
import type { ReactElement } from "react";

export function StatusDot({ active }: { active: boolean }): ReactElement {
  return (
    <Tooltip title={active ? "Active" : "Inactive"}>
      <Box
        component="span"
        aria-label={active ? "Active" : "Inactive"}
        role="img"
        sx={(t) => ({
          display: "inline-block",
          width: 10,
          height: 10,
          borderRadius: "50%",
          bgcolor: active ? t.palette.success.main : "transparent",
          border: active ? "none" : `1.5px solid ${t.palette.text.disabled}`,
        })}
      />
    </Tooltip>
  );
}
